"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireDefault(require("react"));
var _Searchbar = _interopRequireDefault(require("../Searchbar/Searchbar"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _makeStyles["default"])(function (theme) {
  return {
    root: function root(props) {
      return _defineProperty({
        width: "100%",
        maxHeight: "calc(100vh - 80px)",
        overflow: "hidden",
        position: "relative",
        marginBottom: theme.spacing(4),
        zIndex: 0,
        display: "flex",
        justifyContent: "center",
        background: theme.palette.primary.main,
        "&::before": _defineProperty({
          zIndex: "-1",
          content: "''",
          background: theme.palette.primary.main,
          position: "absolute",
          width: 307,
          bottom: -52,
          top: "-14%",
          left: "56.5%",
          clipPath: " polygon(0% 12%, 100% -12%, 0% 94%)"
        }, theme.breakpoints.down('sm'), {
          display: "none"
        }),
        "&::after": {
          zIndex: "-2",
          content: "''",
          backgroundImage: "".concat(props.backgroundImage ? "url(".concat(props.backgroundImage, ")") : null),
          backgroundPosition: "center",
          backgroundSize: "cover",
          position: "absolute",
          width: "43%",
          height: "100%",
          top: 0,
          right: 0
        }
      }, theme.breakpoints.down('sm'), {
        height: "auto",
        // paddingBottom: 50,
        background: "transparent"
      });
    },
    wrapper: function wrapper(props) {
      return {
        width: "100%",
        // marginBottom: 50,
        position: "relative"
      };
    },
    bg: function bg(props) {
      var _ref2;
      return _ref2 = {
        position: "absolute",
        width: "43%",
        height: "100%",
        top: 0,
        right: 0,
        zIndex: -2
      }, _defineProperty(_ref2, theme.breakpoints.down('sm'), {
        width: "100%"
      }), _defineProperty(_ref2, "&:after", _defineProperty({}, theme.breakpoints.down('sm'), {
        content: "''",
        zIndex: 0,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: "linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.35) 7% 90%, rgba(0,0,0,0) 100%)"
      })), _ref2;
    },
    inner: function inner(props) {
      return _defineProperty({
        position: "relative",
        width: theme.breakpoints.values.lg,
        marginBottom: 50,
        maxWidth: "100%",
        paddingTop: 0,
        paddingLeft: 24,
        paddingRight: 24
      }, theme.breakpoints.down('sm'), {
        // paddingTop: 40,
        // paddingBottom: 0,
        // marginBottom: 0,
      });
    },
    image: _defineProperty({
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center"
    }, theme.breakpoints.down('sm'), {
      // display: "flex",
    }),
    searchWrapper: _defineProperty({
      width: theme.breakpoints.values.lg,
      maxWidth: "100%",
      position: "absolute",
      bottom: -73,
      left: "50%",
      transform: "translateX(-50%)",
      paddingLeft: 24,
      paddingRight: 24
    }, theme.breakpoints.down('sm'), {
      position: "relative",
      bottom: "auto",
      transform: "translate(-50%, -80px)"
    }),
    body: function body(props) {
      return _defineProperty({
        minHeight: theme.spacing(11),
        marginTop: 118,
        maxWidth: "64%"
      }, theme.breakpoints.down('sm'), {
        marginTop: 40,
        width: "100%",
        maxWidth: "100%"
      });
    },
    heading: _defineProperty({
      fontSize: 60,
      fontWeight: 600,
      lineHeight: 1.1,
      marginBottom: 8
    }, theme.breakpoints.down('sm'), {
      fontSize: 46
    }),
    subHeading: _defineProperty({
      fontSize: 28,
      fontWeight: 600,
      lineHeight: 1.1,
      marginBottom: 24
    }, theme.breakpoints.down('sm'), {
      fontSize: 24
    }),
    descriptionWrapper: _defineProperty({}, theme.breakpoints.down('sm'), {
      display: "none"
    }),
    descriptionText: _defineProperty({
      fontSize: 20,
      lineHeight: 1.1,
      marginBottom: 24
    }, theme.breakpoints.down('sm'), {
      fontSize: 16
    }),
    text: _defineProperty({
      color: theme.palette.common.white
    }, theme.breakpoints.down('sm'), {
      textShadow: "0 3px 5px rgba(0,0,0,0.2)",
      textAlign: "center"
    })
  };
});
var Hero = function Hero(_ref5) {
  var children = _ref5.children,
    breadcrumb = _ref5.breadcrumb,
    backgroundImage = _ref5.backgroundImage,
    title = _ref5.title,
    subTitle = _ref5.subTitle,
    description = _ref5.description,
    isMobile = _ref5.isMobile;
  var _useStyles = useStyles({
      backgroundImage: backgroundImage,
      isMobile: isMobile
    }),
    root = _useStyles.root,
    wrapper = _useStyles.wrapper,
    inner = _useStyles.inner,
    body = _useStyles.body,
    text = _useStyles.text,
    bg = _useStyles.bg,
    image = _useStyles.image,
    heading = _useStyles.heading,
    subHeading = _useStyles.subHeading,
    descriptionWrapper = _useStyles.descriptionWrapper,
    descriptionText = _useStyles.descriptionText;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bg
  }, _react["default"].Children.map(children, function (child) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      className: (0, _classnames["default"])(child.props.className, image)
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: inner
  }, breadcrumb && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      paddingLeft: 24,
      paddingRight: 24,
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: 30,
      zIndex: 1000,
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      position: "relative",
      width: "100%"
    }
  }, breadcrumb)), /*#__PURE__*/_react["default"].createElement("div", {
    className: body
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    id: "hero-title",
    component: "h1",
    className: (0, _classnames["default"])(text, heading),
    align: "left"
  }, title), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    id: "hero-subtitle",
    component: "h2",
    className: (0, _classnames["default"])(text, subHeading),
    align: "left"
  }, subTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: descriptionWrapper
  }, (description || "").split("\n").map(function (d) {
    return /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      key: d,
      id: "hero-description",
      component: "p",
      className: (0, _classnames["default"])(text, descriptionText),
      align: "left"
    }, d);
  })))))));
};
Hero.propTypes = {
  title: _propTypes["default"].string,
  subTitle: _propTypes["default"].string,
  backgroundImage: _propTypes["default"].string,
  isMobile: _propTypes["default"].bool,
  imageComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  breadcrumb: _propTypes["default"].node
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Hero);